import { React, Fragment, memo, useState, useEffect } from 'react'
import { Avatar } from '@paypalcorp/pp-react'
import asASlide from '../../common/as-a-slide'
import PasswordSent from './PasswordRecovery'
import LinkExpired from './LinkExpired'
import SomethingWrongPage from './SomethingWrong'
import Spinner from '../../../screens/dsr/common/dsr-spinner'
import { PASSWORD_RECOVERY_API } from '../../../constants/constants'
import { serverData } from '../../../utils'
import { get } from '../../../utils/ajax.js'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const VENMOPAGEFPTI = DATAPRIVACY_FPTI.VENMO_PASSWORD_PAGE

const useQuery = (queryParam) => {
  const search = new URLSearchParams(document.location.search)
  return search.get(queryParam)
}

const HomeScreen = memo(() => {
  const [currentState, setCurrentState] = useState('SPINNER')
  const [apiresponse, setAPIResponse] = useState({})
  const token = useQuery('token')

  useEffect(() => {
    if (!token) {
      setCurrentState('SOMETHINGWRONG')
    } else {
      const reqparams = {
        _csrf: serverData._csrf,
        verificationToken: token || '',
      }
      postSMSPasswordRequest(reqparams)
    }
  }, [])

  async function postSMSPasswordRequest(reqparams) {
    const response = await get(
      `${PASSWORD_RECOVERY_API}?token=${reqparams.verificationToken}`,
    )
    if (response && response.data && response.data.status) {
      setCurrentState(response.data.status)
      const resData = response.data
      setAPIResponse({ ...apiresponse, ...resData })
    } else {
      setCurrentState('SOMETHINGWRONG')
    }
  }

  const showState = (state) => {
    const DAR_STATES = {
      SENT: <PasswordSent response={apiresponse} fpti={VENMOPAGEFPTI} />,
      LINK_EXPIRED: <LinkExpired fpti={VENMOPAGEFPTI} />,
      SOMETHINGWRONG: <SomethingWrongPage fpti={VENMOPAGEFPTI} />,
      SPINNER: <Spinner />,
    }
    return DAR_STATES[state]
  }

  return (
    <Fragment>
      <div className="">
        <Avatar
          src={`https://${serverData.cdnHostName}/dataprivacy/digitalassets/dar/venmo_blue_logo.svg`}
          className="venmo_logo"
          alt="venmo_logo"
        />
      </div>

      <div className="venmo-container">
        <section className="venmobody">{showState(currentState)}</section>
      </div>
    </Fragment>
  )
})

HomeScreen.displayName = 'HomeScreen'
export default asASlide({ position: 0 })(HomeScreen)
